import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ArrowLeft"
});
const _hoisted_1 = {
  width: "12px",
  height: "12px",
  viewBox: "0 0 12 12",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-875.000000, -1971.000000)"><g transform="translate(835.000000, 1951.000000)"><g transform="translate(40.000000, 20.000000)"><rect x="0" y="0" width="12" height="12"></rect><path d="M8.74971004,1.99445096 L4.894455,5.99986077 L8.74976902,10.005332 C8.88949855,10.1505037 8.88953183,10.3801462 8.74984437,10.5253585 L8.32296524,10.969121 C8.17938551,11.1183795 7.94199328,11.122983 7.79273484,10.9794032 L3.25020327,6.25983725 C3.11048709,6.11466361 3.11046007,5.88503193 3.25014206,5.7398254 L3.9472275,5.01516972 L7.78257642,1.03087489 C7.91515897,0.8931435 8.127634,0.878695886 8.27689489,0.990257898 L8.31792269,1.02579136 L8.31792269,1.02579136 L8.74972417,1.47436083 C8.88946954,1.6195648 8.8894633,1.84925458 8.74971004,1.99445096 Z" fill="#42526E"></path></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var arrowLeft = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { arrowLeft as default };
